import React from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import "./Adminlayout.css";

function AdminLayout() {
  return (
    <div className="admin-layout">
      {/* ── HIGH-CONTRAST HORIZONTAL NAVIGATION CONTROL ── */}
      <Sidebar />

      <main className="admin-main">
        {/* ── FORMAL CORPORATE BRANDING BANNER BAR ── */}
        <header className="admin-topbar">
          <div className="topbar-branding-container">
            <div className="corporate-logo-box">
              <span className="corporate-icon">ॐ</span>
            </div>
            <div className="corporate-text-meta">
              <h1 className="corporate-title">
                GURUKRUPA PLACEMENT &amp; EDUCATION SOLUTIONS PVT LTD
              </h1>
              <p className="corporate-tagline">
                An International Brand For Serving The People &amp; By The People
              </p>
            </div>
          </div>
          
          {/* Subtle location flag to anchor the design workspace layout */}
          <div className="system-location-tag">
            <span className="status-indicator-dot"></span>
            HQ Console
          </div>
        </header>

        {/* ── MAIN WORKSPACE SUB-PAGE INJECTION FRAME ── */}
        <section className="admin-content">
          <Outlet />
        </section>
      </main>
    </div>
  );
}

export default AdminLayout;